import { InstrumentReference } from '../Instrument/Instrument'
import { Timestamp } from '../Timestamp'

export interface Composition {
  id: string
  createdAt: Timestamp
  validAt: Timestamp
  components: CompositionComponents
}

export interface CompositionComponents {
  instruments: CompositionComponentInstrument[]
  cash: { currency: string; weight: number }[]
  others: number
}

export interface CompositionComponentInstrument {
  instrumentReference: InstrumentReference
  weight: number
}

export const isCompositionEmpty = (composition: Composition) => {
  return (
    composition.components.instruments.length === 0 &&
    composition.components.cash.length === 0 &&
    composition.components.others === 0
  )
}
